import { Button } from "@ariakit/react";
import { ExternalLink, MinWidth, useMediaQuery } from "@indietabletop/appkit";
import type { RecipeVariants } from "@vanilla-extract/recipes";
import { trackEvent } from "../../lib/fathom.tsx";
import bastardsSrc from "./bastards2.webp";
import bastardsSquareSrc from "./bastardsWide.webp";
import { Countdown } from "./Countdown.tsx";
import { banner, compact } from "./style.css.ts";
import { useNewsBanner } from "./useNewsBanner.ts";

type BannerProps = {
  url: string;
  heading: string;
  info: string;
  showUntil: Date;
  publishedAt: Date;
};

export function CompactBanner(
  props: BannerProps & RecipeVariants<typeof compact.container>,
) {
  const { url, heading, info, showUntil, publishedAt, variant } = props;
  const { isVisible, dismiss } = useNewsBanner(publishedAt, showUntil);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={compact.container({ variant })}>
      <ExternalLink
        href={url}
        style={{ display: "contents" }}
        onClick={() => void trackEvent("ks_referral")}
      >
        <img src={bastardsSquareSrc} alt="" className={compact.image} />
      </ExternalLink>

      <div className={compact.content}>
        <div className={compact.heading}>{heading}</div>
        <p className={compact.text}>
          {info}{" "}
          <strong>
            Ends in <Countdown fromDate={showUntil} />.
          </strong>
        </p>

        <div className={compact.actions}>
          <ExternalLink
            href={url}
            onClick={() => void trackEvent("ks_referral")}
            className={compact.back}
          >
            Back now!
          </ExternalLink>

          <Button className={compact.dismiss} onClick={dismiss}>
            Dismiss
          </Button>
        </div>
      </div>
    </div>
  );
}

export function NewsBanner(
  props: {
    url: string;
    showUntil: Date;
    publishedAt: Date;
  } & RecipeVariants<typeof banner.container>,
) {
  const { url, publishedAt, showUntil, variant } = props;
  const { isVisible, dismiss } = useNewsBanner(publishedAt, showUntil);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={banner.container({ variant })}>
      <ExternalLink
        style={{ display: "contents" }}
        href={url}
        onClick={() => void trackEvent("ks_referral")}
      >
        <img src={bastardsSrc} alt="" className={banner.image} />
      </ExternalLink>
      <div className={banner.content}>
        <div className={banner.heading}>Here Come The Bastards</div>
        <div className={banner.subheading}>New Expansion Book!</div>
        <p className={banner.text}>
          Get the new expansion or core rules in hardcover! Digital minis also
          available.{" "}
          <strong>
            Ends in <Countdown fromDate={showUntil} />.
          </strong>
        </p>
        <div className={banner.actions}>
          <ExternalLink
            className={banner.action}
            href={url}
            onClick={() => void trackEvent("ks_referral")}
          >
            Back on Kickstarter
          </ExternalLink>

          <Button className={banner.dismiss} onClick={dismiss}>
            Dismiss
          </Button>
        </div>
      </div>
    </div>
  );
}

export function HereComeTheBastardsBanner(
  props: RecipeVariants<typeof compact.container> &
    RecipeVariants<typeof banner.container>,
) {
  const isMediumOrWider = useMediaQuery(MinWidth.MEDIUM);

  const bannerContent = {
    heading: "Here Come The Bastards",
    publishedAt: new Date("2026-04-15"),
    showUntil: new Date("2026-04-19T22:00:00.000+02:00"),
    url: "https://www.kickstarter.com/projects/planetsmashergames/space-gits-here-come-the-bastards",
  };

  if (!isMediumOrWider) {
    return (
      <CompactBanner
        {...props}
        {...bannerContent}
        info="Back the new expansion on Kickstarter. "
      />
    );
  }

  return <NewsBanner {...props} {...bannerContent} />;
}
